import { useSelector } from 'react-redux'
import { getAdminEventsTree } from '../../redux/user/state'
import Form from 'react-bootstrap/Form'
import { useEffect, useState } from 'react'

const flatten = (input, eventID, indent = 0) => {
  return input
    .filter(event => event.id !== eventID)
    .reduce((agg, event) => {
      agg.push({
        value: event.id,
        label: `${'- '.repeat(indent)} ${event.name}`
      })
      if (Array.isArray(event.children)) {
        agg = agg.concat(flatten(event.children, eventID, indent + 1))
      }
      return agg
    }, [])
}

export default function EventSelector(props) {
  const { event: eventID, onChange, value, name = 'event', label = 'Event', id, size } = props

  const tree = useSelector(state => getAdminEventsTree(state))

  const [flattened, setFlattened] = useState(null)

  useEffect(() => {
    if (tree) {
      setFlattened(flatten(tree, eventID))
    }
  }, [tree])

  if (!flattened || !flattened.length || (value && flattened.findIndex(item => item.value) === -1)) {
    return null
  }

  return (
    <Form.Group controlId={id}>
      <Form.Label className="mt-2 mb-0">{label}</Form.Label>
      <Form.Control
        id={id}
        as="select"
        name={name}
        onChange={onChange}
        value={value}
        size={size}>
        <option value="">None</option>
        {flattened.map(item => (
          <option
            key={item.value}
            value={item.value}>
            {item.label}
          </option>
        ))}
      </Form.Control>
    </Form.Group>
  )
}
